import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollable"]

  scroll() {
    const scrollable = this.hasScrollableTarget ? this.scrollableTarget : window
    scrollable.scrollTo({ top: 0 })
  }
}
